import dxDataGrid from 'devextreme/ui/data_grid';

import { TKey, TColumnVisibility } from 'types/columnDefs';

/* -------------------- */

export const showColumn = (dataGrid: dxDataGrid<unknown, unknown> | undefined) =>
    (field: TKey | number) => {
        dataGrid?.columnOption(field, 'visible', true);
    };

export const hideColumn = (dataGrid: dxDataGrid<unknown, unknown> | undefined) =>
    (field: TKey | number) => {
        dataGrid?.columnOption(field, 'visible', false);
    };

export const setColumnsVisible = (dataGrid: dxDataGrid<unknown, unknown> | undefined) =>
    (columns: TColumnVisibility[]) => {
        for (const col of columns) {
            dataGrid?.columnOption(col.field, 'visible', Boolean(col.visible));
        }
    };
